<template>
  <layout page="serie-list">
    <page-title icon="lni lni-bold" :breadcrumb="breadcrumb">Séries</page-title>
    <div class="card table">
      <header class="card-header">
        <p class="card-header-title">
          <span>Séries</span>
        </p>
        <div class="card-header-icon" aria-label="novo professor">
          <router-link class="button is-primary" to="/admin/series/nova">
            <i class="lni lni-plus mr-1"></i> <span>Nova Série</span>
          </router-link>
        </div>
      </header>
      <div class="card-content">
        <div v-if="series.length > 0" class="table-container">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Nome</th>
                <td class="has-text-right">Ações</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(serie, index) in series" :key="serie.id">
                <td>{{ serie.name }}</td>
                <td class="has-text-right">
                  <router-link class="button is-primary is-small mr-1" :to="`/admin/series/${serie.id}/editar`" title="Editar Série">
                    <i class="lni lni-pencil-alt"></i>
                  </router-link>
                  <button class="button is-danger is-small" title="Excluir Série" @click="excluir(index, serie.id, serie.name)">
                    <i class="lni lni-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <empty-list v-else entity="série" />
      </div>
    </div>
  </layout>
</template>

<script>
import api from '@/api'
import Swal from 'sweetalert2'
import { DASHBOARD, SERIE_LIST } from '@/config/breadcrumb/admin'
import Layout from '@/layout/admin/Layout'
import PageTitle from '@/components/admin/PageTitle'
import EmptyList from '@/components/ui/EmptyList'

export default {
  name: 'SerieList',
  components: {
    Layout,
    PageTitle,
    EmptyList
  },
  created () {
    api.get('/series').then(res => {
      this.series = res.data
    })
  },
  data () {
    return {
      series: []
    }
  },
  computed: {
    breadcrumb () {
      return [
        DASHBOARD,
        { ...SERIE_LIST, isActive: true }
      ]
    }
  },
  methods: {
    excluir (index, id, name) {
      Swal.fire({
        title: 'Tem certeza?',
        text: `Você tem certeza que deseja excluir a série: ${name}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          api.delete(`/series/${id}`).then(res => {
            if (res.status === 200) {
              this.series.splice(index, 1)
            }
          })
        }
      })
    }
  }
}
</script>
